<template>

    <div class="senders-container">

        <div class="senders" id="senders" v-show="senders.length">

            <div class="top">

                <div class="label">
                    <img src="/img/icons/search-circle.svg" class="img__20 mr__8">
                    <p class="text-baseBold">{{ $t('cleaning_search_by_sender') }}</p>
                </div>

                <div class="sender" v-for="sender in senderToShow" @click="senderClick(sender.name)">
                    <div class="left">
                        <span class="text-baseMedium">{{ sender.name }}</span>
                        <span class="text-sRegular color__stone">{{ sender.sender }}</span>
                    </div>
                    <div class="count text-sSemibold">{{ sender.count }}</div>
                    <img src="/img/icons/arrow-side-blue.svg" class="ml__8">
                </div>
            </div>

            <div class="bottom" v-show="!isDesktop">

                <button @click="validate" class="text-lSemibold">{{ $t('cleaning_search_cta') }}</button>

            </div>

        </div>

    </div>

</template>

<script>
import Vuex from 'vuex'

import ENUM from '../../assets/ENUM'

export default {

    name: 'senders',

    computed: {
        ...Vuex.mapGetters([
            'newsletters',
            'searchValue'
        ]),

        senders() {
            const typedSubscriptions = this.newsletters
                .filter(item => item.type === ENUM.NEWSLETTERS.CARDS.SUBSCRIPTIONS)
            return this.searchValue
                ? typedSubscriptions.filter(item => `${item.name} ${item.sender}`.indexOf(this.searchValue) > -1)
                : typedSubscriptions
        },

        senderToShow() {
            return this.senders.slice(0, this.maxSenders)
        },

        computedTextSearching() {
            return this.senders.length
                ? this.$tc('cleaning_search_nb_results', this.senders.length, {'nb_results': this.senders.length, search: this.searchValue})
                : this.$t('cleaning_search_no_results')
        }
    },

    data() {

        return {
            maxSenders: 3
        }
    },

    mounted() {
        this.initData()
    },

    methods: {

        ...Vuex.mapActions([
            'updateSearchValue',
            'updateNewslettersSearchingMode',
            'updateNewslettersPage'
        ]),

        senderClick(sender) {

            this.updateSearchValue(sender)

            if(this.isDesktop) {
                this.validate()
            }
        },

        validate() {
            this.updateNewslettersPage(ENUM.NEWSLETTERS.PAGE.LIST)
            this.updateNewslettersSearchingMode(ENUM.NEWSLETTERS.SEARCHING_MODE.RESULT)
        },

        initData() {
            const sendersHeigth = document.getElementById('senders').offsetHeight
            this.maxSenders = Math.trunc(sendersHeigth / 2 / 52) || 1
        }
    }
}

</script>

<style lang="scss" scoped>

.senders-container {
    @media screen and (min-width: $above-tablet-length) {
        position: absolute;
        display: flex;
        justify-content: center;
        top: -9px;
        left: 0;
        right: 0;
    }
}

.senders {
    background-color: $white;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    flex: 1;
    @media screen and (min-width: $above-tablet-length) {
        max-width: 650px;
        box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.04), 0 4px 16px 0 rgba(0, 0, 0, 0.08);
        border-radius: 16px;
    }


    .top {
        padding: 16px;
        flex: 1;

        @media screen and (min-width: $above-tablet-length) {
            padding-bottom: 0;
        }

        .label {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            font-size: 15px;
            font-weight: bold;

            @media screen and (min-width: $above-tablet-length) {
                font-size: 17px;
                font-weight: 600;
            }
        }

        .sender {
            display: flex;
            padding: 8px 0;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            height: 52px;

            .left {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                flex: 1;
            }

            .count {
                padding: 2px 8px;
                border-radius: 16px;
                background-color: $timberwolf;
            }

            > img {
                width: 12px;
                object-fit: contain;
            }
        }
    }

    .bottom {
        border-top: 1px solid $silver;
        padding: 12px 20px;

        > button {
            width: 100%;
            padding: 16px;
            border-radius: 72px;
            background-color: $blue;
            color: $white
        }
    }
}

</style>
